import { Constant, EVALAUTION_STAGES } from "../helper/constant";

export const setStorageData = (key, data) => {
    window.localStorage.setItem(key, JSON.stringify(data));
};

export const getStorageData = (key) => {
    let data = window.localStorage.getItem(key)
    try {
        data = JSON.parse(data);
        return data;
    } catch (error) {
        console.error("Error parsing data from localStorage:", error);
        return data;
    };
}

export const clearStorage = (key = "") => {
    if (key) {
        window.localStorage.removeItem(key);
    } else {
        window.localStorage.clear();
    }
};

export const getEvaluationPayload = (data) => {
    if (data && data.length) {
        const target_range = getStorageData(Constant.STORAGE_KEYS.TARGET_RANGE) || {};
        data[0].target_range = target_range[EVALAUTION_STAGES.AI_STRATEGY] || 100;
        data[1].target_range = target_range[EVALAUTION_STAGES.AI_VALUE] || 100;
        data[2].target_range = target_range[EVALAUTION_STAGES.AI_ORGANISATION] || 100;
        data[3].target_range = target_range[EVALAUTION_STAGES.AI_PEOPLE_AND_CULTURE] || 100;
        data[4].target_range = target_range[EVALAUTION_STAGES.AI_GOVERNANCE] || 100;
        data[5].target_range = target_range[EVALAUTION_STAGES.AI_ENGINEERING] || 100;
        data[6].target_range = target_range[EVALAUTION_STAGES.AI_DATA] || 100;
    }
    return data;
}